import { createFileRoute } from "@tanstack/react-router"
import { projectDashboardViewStaticData } from "src/views/ProjectDashboardView/constants"
import { ProjectDashboardView } from "src/views/ProjectDashboardView/ProjectDashboardView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/timeline")({
	component: ProjectDashboardView,
	staticData: projectDashboardViewStaticData,
})
